var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgGameCamera = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 31,
    viewBox: "0 0 22 31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.6 0H4.4L0 4.429V26.57L4.4 31h13.2l4.4-4.429V4.43L17.6 0zM11 22.143c-1.215 0-2.2-.992-2.2-2.214 0-1.223.985-2.215 2.2-2.215 1.215 0 2.2.992 2.2 2.215 0 1.222-.985 2.214-2.2 2.214zm0-9.964c-1.823 0-3.3-1.487-3.3-3.322 0-1.834 1.477-3.321 3.3-3.321 1.823 0 3.3 1.487 3.3 3.321 0 .881-.348 1.726-.967 2.349-.618.623-1.458.973-2.333.973z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGameCamera, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/game-camera.887a8055.svg";
export { ForwardRef as ReactComponent };